import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const tokenStore = {
  get: () => localStorage.getItem("kay_admin_token") || "",
  set: (t) => localStorage.setItem("kay_admin_token", t),
  clear: () => localStorage.removeItem("kay_admin_token"),
};

export const api = () => {
  const t = tokenStore.get();
  return axios.create({
    baseURL: BASE,
    headers: t ? { Authorization: `Bearer ${t}` } : {},
    timeout: 20000,
  });
};

export const publicApi = () => axios.create({ baseURL: BASE, timeout: 20000 });
